// extracted by mini-css-extract-plugin
export default {"rating":"dz-z","numberOfStars":"ez-z","count":"fz-z","barGraphSpacing":"gz-z","barGraph":"hz-z"};